import styled from "styled-components";
import { useEffect, useState } from "react";
import LoadingSection from "../../../helperComponents/LoadingSection";
import { serverLine } from "../../../../controllers/network/serverLine";
import CustomButton from "../../../helperComponents/CustomButton";
import MaterialInput from "../../../helperComponents/MaterialInput";
import PermissionGuard from "../../../customUiForCs/PermissionGuard";
import CustomLabel from "../../../customUiForCs/CustomLabel";
import parseDate from "../../../../controllers/parseDate";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  /* margin-top: 100px; */
  align-items: center;
`;

const Inputs = styled.div`
  border-radius: 10px;
  display: flex;
  width: 35vw;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const InputItems = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px;
  gap: 20px;
  border-radius: 20px;
  background-color: var(--surface2);
  border: 1px solid var(--border);
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 15px;
`;

const Buttons = styled.div`
  width: 38vw;
  /* background-color: red; */
  display: flex;
  justify-content: center;
  align-items: center;
`;

const UploadSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  width: 100%;
`;

let dropDownStyle = { flex: 1 };

export default function AddOrEditVacationModular({
  itemID,
  userID,
  loading,
  setLoading,
  purpose,
  callback,
}) {
  const [item, setItem] = useState({});

  useEffect(() => {
    if (purpose == "UPDATE") {
      if (itemID) {
        setLoading(true);
        loadItemToBeEdited();
      }
    }
  }, [itemID, purpose]);

  if (loading) {
    return <LoadingSection />;
  }

  return (
    <PermissionGuard
      permissionName={"vacationPermissions"}
      action={purpose == "ADD" ? "CREATE" : "UPDATE"}
    >
      <Container>
        <Inputs>
          <InputItems>
            <MaterialInput
              type="date"
              label={"Du"}
              value={item.startDate}
              onChange={updateField("startDate")}
            />
            <MaterialInput
              type="date"
              label={"Au"}
              value={item.endDate}
              onChange={updateField("endDate")}
            />

            <MaterialInput
              label={"Commentaire"}
              value={item.note}
              onChange={updateField("note")}
              multiline={true}
              rows={2}
            />
          </InputItems>
          <br />
          <Buttons>
            <CustomButton style={{ padding: "15px 40px" }} onClick={save}>
              {purpose == "UPDATE" ? "Sauvegarder" : "Ajouter"}
            </CustomButton>

            {/* <CustomLabel>{parseDate(item.endDate)}</CustomLabel> */}
          </Buttons>
        </Inputs>
      </Container>
    </PermissionGuard>
  );

  function updateField(fieldName, dontUseEventValue) {
    return (e) => {
      let newItem = { ...item };
      if (dontUseEventValue) {
        newItem[fieldName] = e;
      } else {
        newItem[fieldName] = e.target.value;
      }

      setItem(newItem);
    };
  }

  function save() {
    if (purpose == "UPDATE") editItem();
    if (purpose == "ADD") createItem();
  }

  async function loadItemToBeEdited() {
    let data = await serverLine.get(`/vacation/?itemID=${itemID}`);
    setItem(data);
    setLoading(false);
  }

  async function createItem() {
    setLoading(true);

    try {
      let res = await serverLine.post("/vacation", {
        startDate: item.startDate,
        endDate: item.endDate,
        note: item.note,
        isJustified: item.isJustified,
        userID: userID,
      });

      callback(res);
    } catch (e) {
      window.popupAlert(e.message);
    }

    setLoading(false);
  }

  async function editItem() {
    setLoading(true);

    try {
      let res = await serverLine.patch("/vacation", {
        itemID,
        changes: {
          startDate: item.startDate,
          endDate: item.endDate,
          note: item.note,
          isJustified: item.isJustified,
        },
      });

      callback(res);
    } catch (e) {
      window.popupAlert(e.message);
    }

    setLoading(false);
  }
}
